import React from 'react'; 
import BankBalanceItem from './BankBalanceItem';
 
const BankBalanceHistory = (props) => {
    const {data, isFromPreview} = props;

    return(
        <div>
            <div className="row around-xs inputPair">
                <div className='tbl-bank-balance-header'>
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className='bank-balance-col1 item-float-left'>
                            Bank Name
                        </div>
                        <div className='bank-balance-col2 item-float-left'>
                            Account Number
                        </div>
                        {/* <div className='bank-balance-col3 item-float-left'>
                            Month
                        </div> */}
                        {/* {(isFromPreview === true)&&
                        <div className='bank-balance-col5 item-float-left'>
                            Currency
                        </div>
                        } */}
                        <div className='bank-balance-col4 item-float-left'>
                            Average Month End Balance of Past 6 months
                        </div>
                        {(isFromPreview === false)&&
                        <div className='bank-balance-col5 item-float-left'>
                            Actions
                        </div>
                        }
                    </div>
                </div>
            </div>
            {(data.length === 0)&&
            <div className="row around-xs inputPair">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div className='txt-center'>
                        {isFromPreview?
                        <>No Record</>
                        :
                        <>Click ‘Add Balance Details’ to begin.</>
                        }
                        
                    </div>
                </div>
            </div>
            }
            {data.map((item, idx) => (
            <BankBalanceItem key={idx} item={item} isFromPreview={isFromPreview}
                onClick={(v)=> {
                    props.onItemClick(v,idx,item);
                }}
                />
          ))}
        </div>
    )
}

export default BankBalanceHistory;